export enum ResolvableMissionTypeFormTab {
  GeneralInfo = 'generalInfo',
  Templates = 'templates',
  QuotationHeader = 'quotationHeader',
  ServiceUsages = 'serviceUsages',
  Files = 'files',
  Toolkits = 'toolkits',
}
